import { Observable } from "./Observable";
import { DeliveratorState } from "../gobjects/Deliverator.go";

export default new Observable<DeliveratorState[]>();
